import 'react-multi-carousel/lib/styles.css';

const responsive = {
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
  tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
  mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
};

function CaseStudies() {
  return (
    <>
      {/* ===== Header ===== */}
      <div className="container-fluid bg-breadcrumb11">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">
            Case Studies
          </h4>
        </div>
      </div>

      {/* ===== Body ===== */}
      <div className="container pageiderp">
        <section className="portfolio section-padding" id="portfolio">
          <div className="row">
            <div className="section-title2 wow zoomIn">
              <div className="indented">
                <section>
                  {/* --- Intro paragraph --- */}
                  <div className="case-block intro-block bg-white shadow-sm p-4 rounded mb-5">
                    <p>
                      In this collection of case studies below, Celersoft explores real-world implementations of ERP and SAP
                      solutions, showcasing how we have successfully addressed clients' unique challenges. From streamlining
                      supply chains to improving financial transparency and automating key processes, these examples highlight
                      the transformative power of ERP and SAP in delivering measurable business value in our past projects.
                    </p>
                  </div>

                  {/* =========================================================
                            INTELLIGENT OPERATIONS - COMPLETE SECTION
                      ========================================================= */}

                 <section className="intelligent-operations-complete">

    <div className="container">

        {/* =====================================================
            TOP HEADING
        ====================================================== */}

        <div className="operations-section-heading text-center">

            <span className="operations-eyebrow">
                INTELLIGENT OPERATIONS
            </span>

            <h4 className="operations-title">
                INTELLIGENT OPERATIONS.
                <br />
                <span>MEASURABLE IMPACT.</span>
            </h4>

            <p className="operations-intro">
                Celersoft turns existing cameras, IT/OT systems,
                and operational data into real-time intelligence
                for safer, smarter, more efficient operations.
            </p>

        </div>


        {/* =====================================================
            CONTENT + VIDEO
            LEFT  = CONTENT
            RIGHT = VIDEO
        ====================================================== */}

        <div className="row align-items-center g-5 operations-content-row">


            {/* =================================================
                LEFT CONTENT
            ================================================== */}

            <div className="col-lg-6">

                <div className="operations-content">

                    <h5>
                        One Platform.
                        <br />
                        Real-Time Intelligence.
                    </h5>

                    <p>
                        Transform existing operational environments
                        into intelligent, measurable and proactive
                        systems without replacing your existing
                        infrastructure.
                    </p>

                    <div className="operations-flow">

                        <span>Monitor</span>

                        <i className="fas fa-arrow-right"></i>

                        <span>Detect</span>

                        <i className="fas fa-arrow-right"></i>

                        <span>Analyze</span>

                        <i className="fas fa-arrow-right"></i>

                        <span>Act</span>

                    </div>

                </div>

            </div>


            {/* =================================================
                RIGHT VIDEO
            ================================================== */}

            <div className="col-lg-6">

                <div className="case-video-wrapper">

                    <video
                        className="case-main-video"
                        controls
                        playsInline
                        preload="metadata"
                
                    >

                        <source
                            src="assets/img/Our services Clip.mp4"
                            type="video/mp4"
                        />

                        Your browser does not support the video tag.

                    </video>

                </div>

            </div>

        </div>


        {/* =====================================================
            INDUSTRY INTELLIGENCE
        ====================================================== */}

        <div className="industry-timeline">


            {/* ================= RETAIL ================= */}

            <div className="industry-block">

                <div className="industry-index">
                    <span>01</span>
                </div>

                <div className="industry-main">

                    <div className="industry-heading">

                        <span className="industry-name">
                            RETAIL
                        </span>

                        <h4>
                            Smarter Stores.
                            <br />
                            Better Experiences.
                        </h4>

                    </div>

                    <div className="industry-description">

                        <p>
                            Real-time insights for footfall, queues,
                            inventory, safety, and staffing.
                        </p>

                    </div>

                    <div className="industry-metrics">

                        <div>
                            <strong>1,450+ Footfall</strong>
                        </div>

                        <div>
                            <strong>4 Min Wait Time</strong>
                        </div>

                        <div>
                            <strong>92% Staffing Efficiency</strong>
                        </div>

                    </div>

                </div>

            </div>


            {/* ================= HOSPITALITY ================= */}

            <div className="industry-block">

                <div className="industry-index">
                    <span>02</span>
                </div>

                <div className="industry-main">

                    <div className="industry-heading">

                        <span className="industry-name">
                            HOSPITALITY
                        </span>

                        <h4>
                            Smarter Guest Experiences.
                            <br />
                            Efficient Operations.
                        </h4>

                    </div>

                    <div className="industry-description">

                        <p>
                            Optimize occupancy, guest service, safety,
                            staffing, and facilities.
                        </p>

                    </div>

                    <div className="industry-metrics">

                        <div>
                            <strong>3–5× Loyalty LTV</strong>
                        </div>

                        <div>
                            <strong>&lt;2 Min Check-In Target</strong>
                        </div>

                        <div>
                            <strong>15–25% Labor Efficiency</strong>
                        </div>

                    </div>

                </div>

            </div>


            {/* ================= GAS STATIONS ================= */}

            <div className="industry-block">

                <div className="industry-index">
                    <span>03</span>
                </div>

                <div className="industry-main">

                    <div className="industry-heading">

                        <span className="industry-name">
                            GAS STATIONS
                        </span>

                        <h4>
                            Safer Forecourts.
                            <br />
                            Higher Throughput.
                        </h4>

                    </div>

                    <div className="industry-description">

                        <p>
                            Intelligence for pumps, queues, safety,
                            security, and C-store operations.
                        </p>

                    </div>

                    <div className="industry-metrics">

                        <div>
                            <strong>18% Fewer Drive-Offs</strong>
                        </div>

                        <div>
                            <strong>98.5% Detection Accuracy</strong>
                        </div>

                        <div>
                            <strong>$30B+ Theft Losses</strong>
                        </div>

                    </div>

                </div>

            </div>


            {/* ================= CONSTRUCTION ================= */}

            <div className="industry-block">

                <div className="industry-index">
                    <span>04</span>
                </div>

                <div className="industry-main">

                    <div className="industry-heading">

                        <span className="industry-name">
                            CONSTRUCTION
                        </span>

                        <h4>
                            Safer Sites.
                            <br />
                            Smarter Workforce.
                        </h4>

                    </div>

                    <div className="industry-description">

                        <p>
                            Real-time visibility for PPE, workers,
                            access, assets, and emergencies.
                        </p>

                    </div>

                    <div className="industry-metrics">

                        <div>
                            <strong>
                                20–35% Injury Reduction Potential
                            </strong>
                        </div>

                        <div>
                            <strong>&lt;30 Sec Alerts</strong>
                        </div>

                        <div>
                            <strong>60% Less Sign-In Effort</strong>
                        </div>

                    </div>

                </div>

            </div>


            {/* ================= MANUFACTURING ================= */}

            <div className="industry-block">

                <div className="industry-index">
                    <span>05</span>
                </div>

                <div className="industry-main">

                    <div className="industry-heading">

                        <span className="industry-name">
                            MANUFACTURING
                        </span>

                        <h4>
                            Connected IT + OT.
                            <br />
                            Intelligent Production.
                        </h4>

                    </div>

                    <div className="industry-description">

                        <p>
                            Industrial intelligence for automation,
                            OT security, safety, and predictive
                            operations.
                        </p>

                    </div>

                    <div className="industry-metrics">

                        <div>
                            <strong>PLC / SCADA / CNC</strong>
                        </div>

                        <div>
                            <strong>OT Security Protection</strong>
                        </div>

                        <div>
                            <strong>Predictive Monitoring</strong>
                        </div>

                        <div>
                            <strong>Digital Twin</strong>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>

                  {/* =========================================================
                               CASE STUDY — RANSOMWARE RESPONSE
                         ========================================================= */}

                  <section className="ransomware-case-study">

                    <div className="container">

                      {/* =====================================================
                              SECTION HEADING
                           ====================================================== */}

                      <div className="ransomware-heading">

                        <span className="ransomware-eyebrow">
                          CYBERSECURITY CASE STUDY
                        </span>

                        <h2>
                          <span className="ransomware-title-main">
                            RANSOMWARE RESPONSE
                          </span>
                          <br />
                          <span className="ransomware-title-highlight">
                            & CYBERSECURITY RECOVERY
                          </span>
                        </h2>

                      </div>


                      {/* =====================================================
                            MAIN CONTENT
                             DESKTOP:
                             LEFT  = VIDEO + RESULTS
                             RIGHT = CHALLENGE + SOLUTION

                                  MOBILE:
                                    VIDEO
                                    CHALLENGE
                                        SOLUTION
                                         RESULTS
                             ====================================================== */}

                      <div className="row g-5 ransomware-main-row">


                        {/* =================================================
                                LEFT — VIDEO + RESULTS
                                 ================================================== */}

                        <div className="col-lg-6 ransomware-video-column">


                          {/* =========================
                                     VIDEO
                                ==== ====================== */}

                          <div className="ransomware-video-card">

                            <video
                              className="ransomware-video"
                              controls
                              playsInline
                              preload="metadata"
                            >

                              <source
                                src="/assets/img/Cyber Security Video.mp4"
                                type="video/mp4"
                              />

                              Your browser does not support the video tag.

                            </video>

                          </div>


                          {/* =========================
                                   RESULTS
                               ========================== */}

                          <div className="ransomware-results">

                            <div className="results-heading">
                              <span>THE RESULTS</span>
                            </div>

                            <div className="results-grid">

                              <div>
                                <strong>100%</strong>
                                <span>Data &amp; System Restoration</span>
                              </div>

                              <div>
                                <strong>1 Week</strong>
                                <span>Operations Resumed</span>
                              </div>

                              <div>
                                <strong>2–3 Weeks</strong>
                                <span>Full Normalization</span>
                              </div>

                              <div>
                                <strong>Stronger</strong>
                                <span>Cyber Resilience</span>
                              </div>

                            </div>

                          </div>

                        </div>


                        {/* =================================================
                                         RIGHT — CHALLENGE + SOLUTION
                                ================================================== */}

                        <div className="col-lg-6 ransomware-content-column">

                          <div className="ransomware-content">


                            {/* =========================
                                  THE CHALLENGE
                                  ========================== */}

                            <div className="ransomware-item">

                              <div className="ransomware-icon">

                                <i className="fas fa-exclamation-triangle"></i>

                              </div>

                              <div>

                                <h4>
                                  The Challenge
                                </h4>

                                <p>
                                  A midsized home improvement services agency
                                  suffered a ransomware attack that encrypted
                                  critical schedules, billing records, and
                                  operational data across its on-premise and
                                  cloud environments.
                                </p>

                                <p>
                                  The organization lacked reliable
                                  <strong>
                                    {" "}backup, disaster recovery,
                                    security monitoring, and modern endpoint
                                    protection
                                  </strong>
                                  , resulting in significant operational
                                  disruption.
                                </p>

                              </div>

                            </div>


                            {/* =========================
                                   CELERSOFT'S SOLUTION
                                      ========================== */}

                            <div className="ransomware-item">

                              <div className="ransomware-icon">

                                <i className="fas fa-shield-alt"></i>

                              </div>

                              <div>

                                <h4>
                                  Celersoft's Solution
                                </h4>

                                <p>
                                  Celersoft's cybersecurity team quickly
                                  assessed and contained the incident through:
                                </p>


                                <div className="ransomware-points">

                                  <span>
                                    <i className="fas fa-check"></i>
                                    Incident response &amp; threat assessment
                                  </span>

                                  <span>
                                    <i className="fas fa-check"></i>
                                    Endpoint isolation and EDR
                                  </span>

                                  <span>
                                    <i className="fas fa-check"></i>
                                    Forensic investigation and log analysis
                                  </span>

                                  <span>
                                    <i className="fas fa-check"></i>
                                    Secure data restoration
                                  </span>

                                  <span>
                                    <i className="fas fa-check"></i>
                                    SIEM monitoring and threat validation
                                  </span>

                                  <span>
                                    <i className="fas fa-check"></i>
                                    Backup and disaster recovery implementation
                                  </span>

                                </div>

                              </div>

                            </div>

                          </div>

                        </div>

                      </div>


                      {/* =====================================================
                                  KEY TAKEAWAY
                           ====================================================== */}

                      <div className="ransomware-takeaway">

                        <div className="takeaway-icon">

                          <i className="fas fa-lightbulb"></i>

                        </div>

                        <div>

                          <span>
                            KEY TAKEAWAY
                          </span>

                          <p>
                            Celersoft helps organizations
                            <strong>
                              {" "}respond to ransomware, recover critical
                              operations, and strengthen cyber resilience
                            </strong>
                            {" "}through integrated cybersecurity, incident
                            response, threat detection, and disaster recovery
                            services.
                          </p>

                        </div>

                      </div>

                    </div>

                  </section>

                  {/* ================= Case Study 1 ================= */}
                  {/* <div className="case-block bg-light p-4 rounded shadow-sm mb-5">
                    <h3 className="text-primary mb-3">Case Study 1 – COMD Escravos LPG Sales</h3>
                    <ul>
                      <li>Gas and Condensate are by-products of the crude Oil and Natural Gas processing. Escravos Liquefied Petroleum Gas (LPG) is one of them COMD sells Escravos LPG on behalf of the Federal Government of Nigeria.</li>
                      <li>Escravos LPG is a mixture of different components for e.g. Ethane, Propane etc.</li>
                      <li>Valuation (pricing) of Escravos LPG is based on the weight of the main product and volume (%) of the individual components within the main product.</li>
                      <li>The order to cash process deployed for COMD in 2014/15 deemed unfit to capture Escravos LPG Sales.</li>
                      <li>The solution deployed was resulting in price discrepancies with inability to calculate the unit price of product per MTO.</li>
                      <li>Standard SAP doesn’t allow the provision to calculate the pricing considering weight of main product and volume of individual products.</li>
                      <li>Business were capturing revenue directly in SAP FI module without using SD module to capture Nominations, Liftings and Invoices.</li>
                      <li>SAPCOE designed a new process to capture nominations, liftings and valuations/Invoices of Escravos LPG in SD module thus transferring revenue to FI module.</li>
                      <li>All concerns of business are addressed in the new solution.</li>
                      <li>All required business documents for e.g. Valuation, Invoice, DPR and Marketing clearances are developed to be generated from SAP system.</li>
                      <li>Status – User Acceptance Testing (UAT) completed and mail confirmations received from Business.</li>
                      <li>Go Live plan - Business to capture postings from June, 2020 in live server.</li>
                      <li>A new dashboard is designed to capture the volume percentages of the components of the main product with features to create, edit and save in the database (SAP system).</li>
                      <li>A strong and robust pricing routine is designed to calculate the average price of the main product using the volume percentages, daily prices from publication and the pricing option chosen by customer.</li>
                    </ul>
                    <div className="text-center">
                      <img src="assets/img/lpg-sales.png" alt="LPG Sales" className="img-fluid rounded shadow mt-3" />
                    </div>
                  </div> */}

                  {/* ================= Case Study 2 ================= */}
                  {/* <div className="case-block bg-white p-4 rounded shadow-sm mb-5">
                    <h3 className="text-primary mb-3">Case Study 2 – Crude Oil Trading &amp; LPG Sales Process</h3>
                    <div className="text-center mb-3">
                      <img src="assets/img/lpg-sales2.png" alt="Crude Oil Trading" className="img-fluid rounded shadow" />
                    </div>

                    <p className="text-center mb-4 fw-bold">
                      OPERATIONS DEPARTMENT – Supplier-Input-Process-Output-Customer (SIPOC) model
                    </p>

                    {/* SIPOC grid */}
                  {/* <div className="sipoc-grid">
                      <div className="sipoc-card">
                        <img src="assets/img/suppliers.png" alt="Suppliers" className="sipoc-img" />
                        <h5>Suppliers</h5>
                        <ul>
                          <li>Hyson/CalsonBoard of Directors</li>
                          <li>NNPC/VITOL Top Management</li>
                          <li>COMD</li>
                          <li>PPMC</li>
                          <li>NLNG</li>
                          <li>Hyson/Calson Departments</li>
                          <li>Counterparties</li>
                        </ul>
                      </div>

                      <div className="sipoc-card">
                        <img src="assets/img/inputs.png" alt="Inputs" className="sipoc-img" />
                        <h5>Inputs</h5>
                        <ul>
                          <li>Monthly crude oil allocation under term contract</li>
                          <li>LPG Allocation from PPMC</li>
                          <li>Request for DSDP product supply</li>
                          <li>DSDP Crude Allocation</li>
                          <li>LPG volume from NLNG</li>
                          <li>LPG sourcing from Algasco</li>
                          <li>Term contract acquisition</li>
                        </ul>
                      </div>

                      <div className="sipoc-card">
                        <img src="assets/img/processes.png" alt="Processes" className="sipoc-img" />
                        <h5>Processes</h5>
                        <ul>
                          <li>Crude Oil trading operations</li>
                          <li>DSDP trading operations</li>
                          <li>Domestic LPG sales operations</li>
                          <li>Trading sheet preparation</li>
                          <li>Database management</li>
                          <li>Contract management</li>
                          <li>Vessel nomination</li>
                          <li>Cargo valuation</li>
                          <li>Claims management</li>
                        </ul>
                      </div>

                      <div className="sipoc-card">
                        <img src="assets/img/outputs.png" alt="Outputs" className="sipoc-img" />
                        <h5>Outputs</h5>
                        <ul>
                          <li>Reconciliation report</li>
                          <li>Payment advise</li>
                          <li>Payment receipt</li>
                          <li>Payment confirmation</li>
                          <li>Trading margin report</li>
                          <li>Business Performance report</li>
                          <li>Credit note Utilization</li>
                        </ul>
                      </div>
                    </div> */}

                  {/* ---- Original detailed tables start ---- */}
                  {/* <p>
                      Detail work procedure – NLNG LPG DOMESTIC SALES OPERATIONS (SPA CONTRACT EXECUTION)
                    </p>
                    <table className="casestudylpg">
                      <tbody>
                        <tr>
                          <th>S/N</th>
                          <th>Tasks</th>
                          <th>Steps</th>
                          <th>Timeline as per SPA</th>
                          <th>Task owner</th>
                        </tr>
                        <tr>
                          <td>1</td>
                          <td>Receive contract start up letter from NLNG and notification of quoted price factor.</td>
                          <td>
                            <ul>
                              <li>Hyson communicate Annual Contract Quantity (ACQ) to NLNG</li>
                              <li>Finance Prepare Performance Bond (PB) and Bank Guaranty (BG) for submission to NLNG</li>
                            </ul>
                          </td>
                          <td>Receipt of notification</td>
                          <td>SUPERVISOR <br /> LPG</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>Receive LPG SPA from NLNG</td>
                          <td>
                            <ul>
                              <li>Review of SPA by Commercial and Legal Departments</li>
                              <li>SPA Execution and Sign-off by both parties.</li>
                            </ul>
                          </td>
                          <td>Receipt of notification</td>
                          <td>COMMERCIAL AND LEGAL DEPTS</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>Hyson confirms Terminal User Agreement (TUA) status with NPSC.</td>
                          <td>Hyson Pays Throughput Fees to NPSC and forwards Remita Receipt to NPSC.</td>
                          <td>7 days prior to the arrival of the vessel</td>
                          <td>LPG SUPERVISOR AND FINANCE MANAGER</td>
                        </tr>
                      </tbody>
                    </table>

                    <img src="assets/img/casestudy-spa.png" className="img-fluid my-3" alt="SPA Process" />

                    <p>Detail work procedure – NLNG LPG DOMESTIC SALES OPERATIONS (DISCHARGE AND TRUCKING)</p>
                    <table className="casestudylpg">
                      <tbody>
                        <tr>
                          <th>S/N</th>
                          <th>Tasks</th>
                          <th>Steps</th>
                          <th>Timeline as per SPA</th>
                          <th>Task owner</th>
                        </tr>
                        <tr>
                          <td>1</td>
                          <td>LPG Off-takers appointed Agent nominates product discharge window to NLNG.</td>
                          <td>
                            <ul>
                              <li>NLNG review discharge Laycan/Quantity and sends to HYSON for confirmation</li>
                              <li>HYSON confirms quantity and NLNG sends revised DI to HYSON</li>
                            </ul>
                          </td>
                          <td>10 Days to the 2-day Window</td>
                          <td>LPG SUPERVISOR</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>LPG Off-takers appointed Agent secures berthing window from MTD</td>
                          <td>Approval of Berthing Window communicated to the Off-Takers.</td>
                          <td>5 days prior to the arrival of the vessel</td>
                          <td>LPG SUPERVISOR</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>Vessel arrives Lagos from NLNG, Bonny</td>
                          <td>Vessel Berths at NOJ, BOP, PWA or NAVGAS PRIVATE JETTY and commences discharge to storage facilities.</td>
                          <td>A day before the first day of LAYCAN/WINDOW</td>
                          <td>LPG SUPERVISOR</td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>Product Nomination</td>
                          <td>Sales/Trucking of LPG product to the Domestic Market</td>
                          <td>As soon as the Vessel commences discharge operation</td>
                          <td>LPG SUPERVISOR</td>
                        </tr>
                      </tbody>
                    </table>

                    <img src="assets/img/casestudy-crude.jpg" className="img-fluid my-3" alt="Crude Ops" />

                    <p>Detail work procedure – NLNG LPG DOMESTIC SALES OPERATIONS (INVOICE AND PAYMENTS)</p>
                    <table className="casestudylpg">
                      <thead>
                        <tr>
                          <th>S/N</th><th>Tasks</th><th>Steps</th><th>Timeline as per SPA</th><th>Task owner</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>Hyson receives LPG invoice from NLNG</td>
                          <td>
                            <ul>
                              <li>NLNG review discharge Laycan/Quantity and sends to HYSON for confirmation</li>
                              <li>HYSON confirms quantity and NLNG sends revised DI to HYSON</li>
                            </ul>
                          </td>
                          <td>10 Days to the 2-day Window</td>
                          <td>LPG SUPERVISOR</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>LPG Off-takers appointed Agent secures berthing window from MTD</td>
                          <td>Approval of Berthing Window communicated to the Off-Takers.</td>
                          <td>A day before the first day of LAYCAN/WINDOW</td>
                          <td>LPG SUPERVISOR</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>Vessel arrives Lagos from NLNG, Bonny</td>
                          <td>Vessel Berths at NOJ, BOP, PWA or NAVGAS PRIVATE JETTY and commences discharge to storage facilities.</td>
                          <td>A day before the first day of LAYCAN/WINDOW</td>
                          <td>LPG SUPERVISOR</td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>Product Nomination</td>
                          <td>Sales/Trucking of LPG product to the Domestic Market</td>
                          <td>As soon as the Vessel commences discharge operation</td>
                          <td>LPG SUPERVISOR</td>
                        </tr>
                      </tbody>
                    </table>
                  </div> */}

                  {/* ================= Case Study 3 ================= */}
                  {/* <div className="case-block bg-light p-4 rounded shadow-sm mb-5">
                    <h3 className="text-primary mb-4">Case Study 3 – Cyber Security (Ransomware Response)</h3> */}

                  {/* --- Section 1 --- */}
                  {/* <div className="row align-items-center mb-5">
                      <div className="col-md-6">
                        <img src="assets/img/cybersecurity/CelersoftIntroductionMission1.jpg" alt="Celersoft Introduction and Mission" className="img-fluid rounded shadow" />
                      </div>
                      <div className="col-md-6">
                        <h4>Celersoft Introduction and Mission</h4>
                        <p>
                          A midsized Home improvement Services Agency suffered a Ransomware attack when an employee unknowingly opened a malicious email. The malware spread quickly through shared folders, encrypting job schedules, customer billing records, and route management data on the on-premise server. Because the server replicated to the cloud in real time, the ransomware also encrypted the cloud environment—which had no reliable backup.</p>
                        <p>The agency soon realized its IT provider lacked a true backup and disaster recovery plan. That’s when they turned to Celersoft.</p>


                      </div>
                    </div> */}

                  {/* --- Section 2 --- */}
                  {/* <div className="row align-items-center flex-row-reverse mb-5">
                      <div className="col-md-6">
                        <img src="assets/img/cybersecurity/IncidentContext.png" alt="Introduction – The Incident Context" className="img-fluid rounded shadow" />
                      </div>
                      <div className="col-md-6">
                        <h4>Introduction – The Incident Context</h4>
                        <p>
                          A large enterprise reported encrypted data, inaccessible critical services, and ransom demands. Celersoft’s cyber-incident response team was engaged to assess the breach, isolate affected infrastructure, and coordinate with internal IT for containment.
                        </p>
                      </div>
                    </div> */}

                  {/* --- Section 3 --- */}
                  {/* <div className="row align-items-center mb-5">
                      <div className="col-md-6">
                        <img src="assets/img/cybersecurity/Challenges.jpg" alt="Challenges" className="img-fluid rounded shadow" />
                      </div>
                      <div className="col-md-6">
                        <h4>Challenges</h4>
                        <p>Our assessment revealed:</p>
                        <ul>
                          <li>No Disaster Recovery plan.</li>
                          <li>	No valid backup system.</li>
                          <li>Outdated firewall and antivirus protection.</li>
                          <li>	Weak patch management.</li>
                          <li>	Minimal monitoring of systems.</li>

                        </ul>
                        <p>This left the business unable to access schedules, billing or client records during peak service season.</p>

                      </div>
                    </div> */}

                  {/* --- Section 4 --- */}
                  {/* <div className="row align-items-center flex-row-reverse mb-5">
                      <div className="col-md-6">
                        <img src="assets/img/cybersecurity/Challenges_11zon.png" alt="Challenges Continued" className="img-fluid rounded shadow" />
                      </div>
                      <div className="col-md-6">
                        <p>
                          The compounded challenge involved restoration across hybrid cloud environments while ensuring no dormant malicious code persisted. The incident required simultaneous forensic analysis, restoration, and preventive reinforcement.
                        </p>
                      </div>
                    </div> */}

                  {/* --- Section 5 --- */}
                  {/* <div className="row align-items-center mb-5">
                      <div className="col-md-6">
                        <img src="assets/img/cybersecurity/CelersoftResponse.png" alt="Celersoft’s Response – Assessment and Action" className="img-fluid rounded shadow" />
                      </div>
                      <div className="col-md-6">
                        <h4>Celersoft’s Response – Assessment and Action</h4>
                        <p>
                          Our response began with comprehensive threat assessment, endpoint isolation, and log analysis to determine infection vectors. Using advanced EDR and forensic tools, our analysts mapped attack timelines and blocked persistence mechanisms.
                        </p>
                      </div>
                    </div> */}

                  {/* --- Section 6 --- */}
                  {/* <div className="row align-items-center flex-row-reverse mb-5">
                      <div className="col-md-6">
                        <img src="assets/img/cybersecurity/CelersoftResponse2.png" alt="Celersoft’s Response – Assessment and Action (2)" className="img-fluid rounded shadow" />
                      </div>
                      <div className="col-md-6">
                        <p>
                          Phase 2 included full-scale remediation: decryptor evaluation, secure restoration from validated snapshots, and SIEM correlation to confirm full neutralization. Celersoft coordinated with client stakeholders to resume core operations safely.
                        </p>
                      </div>
                    </div> */}

                  {/* --- Section 7 --- */}
                  {/* <div className="row align-items-center mb-5">
                      <div className="col-md-6">
                        <img src="assets/img/cybersecurity/Communication.png" alt="Communication" className="img-fluid rounded shadow" />
                      </div>
                      <div className="col-md-6">
                        <h4>Communication</h4>
                        <p>
                          Transparent communication was maintained with executives, IT teams, and compliance officers throughout the recovery cycle. Celersoft provided hourly status updates, ensuring decisions were informed and data integrity verified.
                        </p>
                      </div>
                    </div> */}

                  {/* --- Section 8 --- */}
                  {/* <div className="row align-items-center flex-row-reverse mb-5">
                      <div className="col-md-6">
                        <img src="assets/img/cybersecurity/Results.png" alt="Results" className="img-fluid rounded shadow" />
                      </div>
                      <div className="col-md-6">
                        <h4>Results</h4>
                        <ul>
                          <li>	100% restoration of data and systems.</li>
                          <li>Lawn care operations resumed within 1 week; full normalization in 2–3 weeks.</li>
                          <li>	Robust security and disaster recovery solutions implemented.</li>
                          <li>	Improved business continuity for seasonal demand</li>
                        </ul>
                        <p>The agency praised Celersoft’s rapid response and clear communication</p>
                      </div>
                    </div> */}

                  {/* --- Section 9 --- */}
                  {/* <div className="row align-items-center mb-5">
                      <div className="col-md-6">
                        <img src="assets/img/cybersecurity/LessonsLearned.png" alt="Lessons Learned" className="img-fluid rounded shadow" />
                      </div>
                      <div className="col-md-6">
                        <h4>Lessons Learned</h4>
                        <p>
                          Before Celersoft, the agency lacked training and modern security. Now they benefit from:

                        </p>
                        <ul>
                          <li>Firewall with threat management.</li>
                          <li>Reliable backup/disaster recovery.</li>
                          <li>Endpoint Protection and spam-filtered email.</li>
                          <li>Ongoing cybersecurity training.</li>
                        </ul>
                      </div>
                    </div> */}

                  {/* --- Section 10 --- */}
                  {/* <div className="row align-items-center flex-row-reverse mb-4">
                      <div className="col-md-6">
                        <img src="assets/img/cybersecurity/Takeaway.jpg" alt="Takeaway" className="img-fluid rounded shadow" />
                      </div>
                      <div className="col-md-6">
                        <h4>Takeaway</h4>
                        <p>
                          Ransomware can cripple service providers during their busiest season. Celersoft not only restores operations but builds long-term resilience for customer-focused businesses.
                        </p>
                      </div>
                    </div>
                  </div> */}


                  <section className="lpg-case-study">

                    <div className="container">

                      {/* =====================================================
            SECTION HEADING
        ====================================================== */}

                      <div className="lpg-heading">

                        <span className="lpg-eyebrow">
                          SAP SOLUTIONS CASE STUDY
                        </span>

                        <h2>
                          <span className="lpg-title-main">
                            TRANSFORMING COMPLEX LPG SALES
                          </span>
                          <br />
                          <span className="lpg-title-highlight">
                            WITH CELERSOFT SAP SOLUTIONS
                          </span>
                        </h2>

                      </div>


                      {/* =====================================================
            CHALLENGE + VIDEO
        ====================================================== */}

                      <div className="row align-items-center g-5 lpg-main-row">


                        {/* =================================================
                LEFT — THE CHALLENGE
            ================================================== */}

                        <div className="col-lg-6 lpg-content-column">

                          <div className="lpg-content">

                            <div className="lpg-item">

                              <div className="lpg-icon">
                                <i className="fas fa-exclamation-triangle"></i>
                              </div>

                              <div>

                                <h4>
                                  The Challenge
                                </h4>

                                <p>
                                  COMD’s existing SAP Order-to-Cash process
                                  could not effectively support the
                                  <strong>
                                    {" "}complex pricing and valuation
                                    requirements of Escravos LPG.
                                  </strong>
                                </p>

                                <p>
                                  Pricing discrepancies, limited
                                  component-based pricing, manual FI revenue
                                  posting, and disconnected sales processes
                                  created operational and financial challenges.
                                </p>

                              </div>

                            </div>

                          </div>

                        </div>


                        {/* =================================================
                RIGHT — VIDEO
            ================================================== */}

                        <div className="col-lg-6 lpg-video-column">

                          <div className="lpg-video-card">

                            <video
                              className="lpg-video"
                              controls
                              playsInline
                              preload="metadata"
                            >

                              <source
                                src="/assets/img/SAP.mp4"
                                type="video/mp4"
                              />

                              Your browser does not support the video tag.

                            </video>

                          </div>

                        </div>

                      </div>


                      {/* =====================================================
            FULL WIDTH — THE RESULTS
        ====================================================== */}

                      <div className="lpg-results-box">

                        <div className="lpg-results-header">

                          <div className="lpg-results-icon">

                            <i className="fas fa-chart-line"></i>

                          </div>

                          <h4>
                            The Results
                          </h4>

                        </div>


                        <div className="lpg-results-text">

                          <p>
                            CelerSoft implemented an
                            <strong>
                              {" "}integrated SAP SD and FI solution
                            </strong>
                            {" "}that streamlined the complete LPG sales
                            lifecycle—from
                            <strong>
                              {" "}nomination and delivery to component-based
                              valuation, billing, invoicing, and revenue
                              recognition.
                            </strong>
                          </p>

                          <p>
                            Custom pricing logic and a component-volume dashboard
                            improved
                            <strong>
                              {" "}pricing accuracy, visibility, control,
                              and traceability.
                            </strong>
                          </p>

                        </div>

                      </div>


                      {/* =====================================================
            KEY TAKEAWAY
        ====================================================== */}

                      <div className="lpg-takeaway">

                        <div className="lpg-takeaway-icon">

                          <i className="fas fa-lightbulb"></i>

                        </div>

                        <div>

                          <span>
                            KEY TAKEAWAY
                          </span>

                          <p>
                            <strong>
                              CelerSoft transformed a complex LPG sales process
                              into an integrated, controlled, and scalable SAP
                              solution
                            </strong>
                            {" "}—connecting commercial operations, pricing,
                            billing, and finance through one streamlined workflow.
                          </p>

                        </div>

                      </div>

                    </div>

                  </section>

                  <section className="erp-case-study">

    <div className="container">

        {/* =====================================================
            SECTION HEADING
        ====================================================== */}

        <div className="erp-heading">

            <span className="erp-eyebrow">
                ERP SOLUTIONS CASE STUDY
            </span>

            <h2>
                <span className="erp-title-main">
                    TRANSFORMING DISCONNECTED OPERATIONS
                </span>
                <br />
                <span className="erp-title-highlight">
                    INTO INTELLIGENT BUSINESS
                </span>
            </h2>

        </div>


        {/* =====================================================
            CHALLENGE + VIDEO
        ====================================================== */}

        <div className="row align-items-center g-5 erp-main-row">


            {/* =================================================
                LEFT — THE CHALLENGE
            ================================================== */}

            <div className="col-lg-6 erp-content-column">

                <div className="erp-content">

                    <div className="erp-item">

                        <div className="erp-icon">

                            <i className="fas fa-exclamation-triangle"></i>

                        </div>

                        <div>

                            <h4>
                                The Challenge
                            </h4>

                            <p>
                                A growing enterprise was managing sales,
                                inventory, procurement, finance, and
                                operations across disconnected systems.
                            </p>

                            <p>
                                Manual data entry, duplicate information,
                                delayed reporting, and limited visibility
                                made it difficult to coordinate teams and
                                respond quickly to business needs.
                            </p>

                        </div>

                    </div>

                </div>

            </div>


            {/* =================================================
                RIGHT — VIDEO
            ================================================== */}

            <div className="col-lg-6 erp-video-column">

                <div className="erp-video-card">

                    <video
                        className="erp-video"
                        controls
                        playsInline
                        preload="metadata"
                    >

                        <source
                            src="/assets/img/ERP.mp4"
                            type="video/mp4"
                        />

                        Your browser does not support the video tag.

                    </video>

                </div>

            </div>

        </div>


        {/* =====================================================
            FULL WIDTH — THE RESULTS
        ====================================================== */}

        <div className="erp-results-box">

            <div className="erp-results-header">

                <div className="erp-results-icon">

                    <i className="fas fa-chart-line"></i>

                </div>

                <h4>
                    The Results
                </h4>

            </div>


            <div className="erp-results-text">

                <p>
                    CelerSoft implemented an
                    <strong>
                        {" "}integrated ERP ecosystem
                    </strong>
                    {" "}that connected critical business functions
                    through centralized data and automated workflows.
                </p>

                <p>
                    Teams gained
                    <strong>
                        {" "}real-time visibility, streamlined processes,
                        improved data accuracy, and faster access to
                        actionable business insights.
                    </strong>
                </p>

            </div>

        </div>


        {/* =====================================================
            KEY TAKEAWAY
        ====================================================== */}

        <div className="erp-takeaway">

            <div className="erp-takeaway-icon">

                <i className="fas fa-lightbulb"></i>

            </div>

            <div>

                <span>
                    KEY TAKEAWAY
                </span>

                <p>
                    By connecting people, processes, and data,
                    <strong>
                        {" "}CelerSoft transformed fragmented operations
                        into a more connected and intelligent business
                        environment
                    </strong>
                    {" "}—helping the organization improve efficiency,
                    strengthen control, and make faster, data-driven
                    decisions.
                </p>

            </div>

        </div>

    </div>

</section>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* ===== Footer ===== */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana – 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Back-to-Top Button ===== */}
      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <i className="fa fa-arrow-up" />
      </button>
    </>
  );
}

export default CaseStudies;
